/* La Banda del Riccio — gallery prodotto (stesso pattern di bdr-hero-slider.js) */

(function () {
  document.querySelectorAll('[data-bdr-gallery]').forEach(function (gallery) {
    var slides    = Array.from(gallery.querySelectorAll('.bdr-gallery__slide'));
    var thumbs    = Array.from(gallery.querySelectorAll('.bdr-gallery__thumb'));
    var prevBtns  = Array.from(gallery.querySelectorAll('.bdr-gallery__btn--prev'));
    var nextBtns  = Array.from(gallery.querySelectorAll('.bdr-gallery__btn--next'));
    var viewer    = gallery.querySelector('.bdr-gallery__viewer');

    if (slides.length < 2) return;

    var current = 0;

    function goTo(n) {
      n = ((n % slides.length) + slides.length) % slides.length;
      if (n === current) return;
      slides[current].classList.remove('is-active');
      if (thumbs[current]) thumbs[current].classList.remove('is-active');
      current = n;
      slides[current].classList.add('is-active');
      if (thumbs[current]) {
        thumbs[current].classList.add('is-active');
        thumbs[current].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    }

    prevBtns.forEach(function (btn) { btn.addEventListener('click', function () { goTo(current - 1); }); });
    nextBtns.forEach(function (btn) { btn.addEventListener('click', function () { goTo(current + 1); }); });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    var touchX = 0;
    viewer.addEventListener('touchstart', function (e) {
      touchX = e.changedTouches[0].clientX;
    }, { passive: true });
    viewer.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 50) goTo(delta < 0 ? current + 1 : current - 1);
    }, { passive: true });

    /* ------------------------------------------------------------------ */
    /* Lightbox                                                             */
    /* ------------------------------------------------------------------ */

    var lightbox = document.querySelector('[data-bdr-lightbox]');
    if (!lightbox) return;

    var lbImg     = lightbox.querySelector('.bdr-lightbox__img');
    var lbCounter = lightbox.querySelector('.bdr-lightbox__counter');
    var lbPrev    = lightbox.querySelector('.bdr-lightbox__btn--prev');
    var lbNext    = lightbox.querySelector('.bdr-lightbox__btn--next');
    var lbClose   = lightbox.querySelector('.bdr-lightbox__close');
    var lbIndex   = 0;
    var lbTouchX  = 0;

    function updateLightbox() {
      var slide = slides[lbIndex];
      lbImg.src = slide.dataset.fullSrc || slide.querySelector('img').src;
      lbImg.alt = slide.dataset.alt || '';
      if (lbCounter) lbCounter.textContent = (lbIndex + 1) + ' / ' + slides.length;
    }

    var stickyBar = document.querySelector('.bdr-sticky-bar');

    function openLightbox(index) {
      lbIndex = index;
      updateLightbox();
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (stickyBar) stickyBar.style.display = 'none';
    }

    function closeLightbox() {
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (stickyBar) stickyBar.style.display = '';
    }

    function lbGoTo(n) {
      lbIndex = ((n % slides.length) + slides.length) % slides.length;
      updateLightbox();
    }

    viewer.addEventListener('click', function (e) {
      if (e.target.closest('.bdr-gallery__btn')) return;
      openLightbox(current);
    });

    lbClose.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    lbPrev.addEventListener('click', function () { lbGoTo(lbIndex - 1); });
    lbNext.addEventListener('click', function () { lbGoTo(lbIndex + 1); });

    lightbox.addEventListener('touchstart', function (e) {
      lbTouchX = e.changedTouches[0].clientX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - lbTouchX;
      if (Math.abs(delta) > 50) lbGoTo(delta < 0 ? lbIndex + 1 : lbIndex - 1);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (lightbox.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape')      closeLightbox();
      if (e.key === 'ArrowLeft')   lbGoTo(lbIndex - 1);
      if (e.key === 'ArrowRight')  lbGoTo(lbIndex + 1);
    });
  });
})();
